var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rounded bg-white shadow-md",staticStyle:{"min-height":"590px"}},[_c('contact-external-email-section',{attrs:{"contact":_vm.contact,"email":_vm.contact.email,"can-edit":'true',"exchange":_vm.exchange,"hasSequencesAccess":_vm.hasSequencesAccess,"company":_vm.company}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }